import React from "react";
import { Flex, Text } from "@fluentui/react-northstar";

const EmptyFolder = () => {
    return (
        <Flex hAlign="center" vAlign="center" styles={{ paddingTop: "52px" }}>
            <Text content="Ce dossier est vide." />
        </Flex>
    );
};

export default EmptyFolder;
